enum Interest_Type {
	LEGAL = 'LEGAL',
	CONTRACTUAL = 'CONTRACTUAL'
}

export enum Period {
	WEEKLY = 'WEEKLY',
    BI_WEEKLY = 'BI_WEEKLY',
    MONTHLY = 'MONTHLY',
    YEARLY = 'YEARLY'
}

interface Indemnification {
	version: string;
	percentage: number;
	minimum_amount: number;
	maximum_amount: number;
	enabled_by_default?: boolean;
	enabled?: boolean;
}

interface Interest {
	version: string;
	type: Interest_Type;
	rate_percentage: number;
	enabled_by_default?: boolean;
	enabled?: boolean;
}

interface Duration {
	version: string;
	duration: number;
	period: Period;
}

export type Payment_Plan_Conditions = {
	version: string;
	indemnification: Indemnification;
	interest: Interest;
	frequency: Period;
	maximum_duration?: Duration;
}
